/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../app/app.module';
import * as i2 from '../../app/app.component';
import * as i3 from './core/route-logged/route-logged.component.ngfactory';
import * as i4 from './custom/horses/horses.component.ngfactory';
import * as i5 from './custom/horse/horse.component.ngfactory';
import * as i6 from './custom/profile/profile.component.ngfactory';
import * as i7 from './custom/cat/cat.component.ngfactory';
import * as i8 from './custom/admin-report/admin-report.component.ngfactory';
import * as i9 from './custom/weight-reporting/weight-reporting.component.ngfactory';
import * as i10 from './custom/rule-book/rule-book.component.ngfactory';
import * as i11 from './custom/contact/contact.component.ngfactory';
import * as i12 from './custom/all-treatments/all-treatments.component.ngfactory';
import * as i13 from './custom/yards/yards.component.ngfactory';
import * as i14 from './custom/billing/billing.component.ngfactory';
import * as i15 from './custom/invoices/invoices.component.ngfactory';
import * as i16 from './custom/info/info.component.ngfactory';
import * as i17 from './auth/login/login.component.ngfactory';
import * as i18 from './auth/sign/sign.component.ngfactory';
import * as i19 from './auth/forgot/forgot.component.ngfactory';
import * as i20 from './custom/rules-unauth/rules-unauth.component.ngfactory';
import * as i21 from './custom/locate-unauth/locate-unauth.component.ngfactory';
import * as i22 from '../../$$_gendir/node_modules/ngx-bootstrap/popover/popover-container.component.ngfactory';
import * as i23 from '../../$$_gendir/node_modules/ngx-bootstrap/datepicker/datepicker.component.ngfactory';
import * as i24 from '../../$$_gendir/node_modules/ngx-bootstrap/dropdown/bs-dropdown-container.component.ngfactory';
import * as i25 from './app.component.ngfactory';
import * as i26 from '@angular/common';
import * as i27 from '@angular/platform-browser';
import * as i28 from '@angular/animations/browser';
import * as i29 from '@angular/platform-browser/animations';
import * as i30 from '@angular/forms';
import * as i31 from '@angular/http';
import * as i32 from '../../app/auth/auth.service';
import * as i33 from '../../app/auth/auth-http.service';
import * as i34 from '@angular/router';
import * as i35 from '@angular/common/http';
import * as i36 from '../../app/auth/auth-guard.service';
import * as i37 from '../../app/auth/country-guard.service';
import * as i38 from 'ngx-window-token/dist/src/ngx-window-token';
import * as i39 from 'ngx-clipboard/src/clipboard.service';
import * as i40 from '@angular/animations';
import * as i41 from 'angular2-notifications/src/simple-notifications/services/notifications.service';
import * as i42 from 'ngx-bootstrap/tabs/tabset.config';
import * as i43 from 'ngx-bootstrap/popover/popover.config';
import * as i44 from 'ngx-bootstrap/positioning/positioning.service';
import * as i45 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i46 from '../../app/core/angular2-image-upload/image.service';
import * as i47 from 'ngx-bootstrap/datepicker/datepicker.config';
import * as i48 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
import * as i49 from '@ngx-translate/core/src/translate.loader';
import * as i50 from '@ngx-translate/core/src/translate.compiler';
import * as i51 from '@ngx-translate/core/src/translate.parser';
import * as i52 from '@ngx-translate/core/src/missing-translation-handler';
import * as i53 from '@ngx-translate/core/src/translate.store';
import * as i54 from '@ngx-translate/core/src/translate.service';
import * as i55 from 'ngx-stripe';
import * as i56 from '../../app/core/billing.service';
import * as i57 from '../../app/core/get.service';
import * as i58 from '../../app/core/app-memory.service';
import * as i59 from '../../app/core/admin-report.service';
import * as i60 from '../../app/PushServices/socet.service';
import * as i61 from '../../app/custom/billing/billing.component';
import * as i62 from '../../app/core/pipes/date-obj.pipe';
import * as i63 from 'angular2-text-mask/dist/angular2TextMask';
import * as i64 from '../../app/core/route-logged/route-logged.component';
import * as i65 from '../../app/custom/horses/horses.component';
import * as i66 from '../../app/custom/horse/horse.component';
import * as i67 from '../../app/custom/profile/profile.component';
import * as i68 from '../../app/custom/cat/cat.component';
import * as i69 from '../../app/custom/admin-report/admin-report.component';
import * as i70 from '../../app/custom/weight-reporting/weight-reporting.component';
import * as i71 from '../../app/custom/rule-book/rule-book.component';
import * as i72 from '../../app/custom/contact/contact.component';
import * as i73 from '../../app/custom/all-treatments/all-treatments.component';
import * as i74 from '../../app/custom/yards/yards.component';
import * as i75 from '../../app/custom/invoices/invoices.component';
import * as i76 from '../../app/custom/info/info.component';
import * as i77 from '../../app/auth/login/login.component';
import * as i78 from '../../app/auth/sign/sign.component';
import * as i79 from '../../app/auth/forgot/forgot.component';
import * as i80 from '../../app/custom/rules-unauth/rules-unauth.component';
import * as i81 from '../../app/custom/locate-unauth/locate-unauth.component';
import * as i82 from '../../app/app-routing.module';
import * as i83 from '../../app/auth/auth-routing.module';
import * as i84 from 'ngx-clipboard/src/index';
import * as i85 from 'ng2-select/select/select.module';
import * as i86 from 'ngx-bootstrap/tabs/tabs.module';
import * as i87 from 'ngx-bootstrap/buttons/buttons.module';
import * as i88 from 'ngx-bootstrap/popover/popover.module';
import * as i89 from '../../app/core/angular2-image-upload/image-upload.module';
import * as i90 from 'ngx-bootstrap/datepicker/datepicker.module';
import * as i91 from 'angular2-notifications/src/simple-notifications.module';
import * as i92 from 'ngx-bootstrap/dropdown/bs-dropdown.module';
import * as i93 from '@ngx-translate/core/index';
import * as i94 from 'ng4-charts/charts/charts';
import * as i95 from 'ng2-pdf-viewer/dist/index';
import * as i96 from 'ngx-bootstrap/dropdown/bs-dropdown.config';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.RouteLoggedComponentNgFactory,i4.HorsesComponentNgFactory,i5.HorseComponentNgFactory,
              i6.ProfileComponentNgFactory,i7.CatComponentNgFactory,i8.AdminReportComponentNgFactory,
              i9.WeightReportingComponentNgFactory,i10.RuleBookComponentNgFactory,
              i11.ContactComponentNgFactory,i12.AllTreatmentsComponentNgFactory,i13.YardsComponentNgFactory,
              i14.BillingComponentNgFactory,i15.InvoicesComponentNgFactory,i16.InfoComponentNgFactory,
              i17.LoginComponentNgFactory,i18.SignComponentNgFactory,i19.ForgotComponentNgFactory,
              i20.RulesUnauthComponentNgFactory,i21.LocateUnauthComponentNgFactory,
              i22.PopoverContainerComponentNgFactory,i23.DatePickerComponentNgFactory,
              i24.BsDropdownContainerComponentNgFactory,i25.AppComponentNgFactory]],
              [3,i0.ComponentFactoryResolver],i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,
          i0.ɵm,[[3,i0.LOCALE_ID]]),i0.ɵmpd(4608,i26.NgLocalization,i26.NgLocaleLocalization,
          [i0.LOCALE_ID]),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,
          i0.IterableDiffers,i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,
          i0.ɵl,([] as any[])),i0.ɵmpd(4608,i27.DomSanitizer,i27.ɵe,[i26.DOCUMENT]),
          i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i27.DomSanitizer]),i0.ɵmpd(4608,
              i27.HAMMER_GESTURE_CONFIG,i27.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,
              i27.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i27.ɵDomEventsPlugin(p0_0),new i27.ɵKeyEventsPlugin(p1_0),
                    new i27.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i26.DOCUMENT,i26.DOCUMENT,i26.DOCUMENT,i27.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i27.EventManager,i27.EventManager,[i27.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i27.ɵDomSharedStylesHost,i27.ɵDomSharedStylesHost,
              [i26.DOCUMENT]),i0.ɵmpd(4608,i27.ɵDomRendererFactory2,i27.ɵDomRendererFactory2,
              [i27.EventManager,i27.ɵDomSharedStylesHost]),i0.ɵmpd(4608,i28.AnimationDriver,
              i28.ɵNoopAnimationDriver,([] as any[])),i0.ɵmpd(5120,i28.ɵAnimationStyleNormalizer,
              i29.ɵd,([] as any[])),i0.ɵmpd(4608,i28.ɵAnimationEngine,i29.ɵb,[i28.AnimationDriver,
              i28.ɵAnimationStyleNormalizer]),i0.ɵmpd(5120,i0.RendererFactory2,i29.ɵe,
              [i27.ɵDomRendererFactory2,i28.ɵAnimationEngine,i0.NgZone]),i0.ɵmpd(6144,
              i27.ɵSharedStylesHost,(null as any),[i27.ɵDomSharedStylesHost]),i0.ɵmpd(4608,
              i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i27.Meta,i27.Meta,
              [i26.DOCUMENT]),i0.ɵmpd(4608,i27.Title,i27.Title,[i26.DOCUMENT]),i0.ɵmpd(4608,
              i30.ɵi,i30.ɵi,([] as any[])),i0.ɵmpd(4608,i31.BrowserXhr,i31.BrowserXhr,
              ([] as any[])),i0.ɵmpd(4608,i31.ResponseOptions,i31.BaseResponseOptions,
              ([] as any[])),i0.ɵmpd(5120,i31.XSRFStrategy,i31.ɵb,([] as any[])),i0.ɵmpd(4608,
              i31.XHRBackend,i31.XHRBackend,[i31.BrowserXhr,i31.ResponseOptions,i31.XSRFStrategy]),
          i0.ɵmpd(4608,i31.RequestOptions,i31.BaseRequestOptions,([] as any[])),i0.ɵmpd(4608,
              i32.AuthService,i32.AuthService,([] as any[])),i0.ɵmpd(4608,i31.Http,
              i33.AuthenticatedHttpService,[i31.XHRBackend,i31.RequestOptions,i32.AuthService,
                  i34.Router]),i0.ɵmpd(4608,i35.HttpXsrfTokenExtractor,i35.ɵg,[i26.DOCUMENT,
              i0.PLATFORM_ID,i35.ɵe]),i0.ɵmpd(4608,i35.ɵh,i35.ɵh,[i35.HttpXsrfTokenExtractor,
              i35.ɵf]),i0.ɵmpd(5120,i35.HTTP_INTERCEPTORS,(p0_0:any) => {
            return [p0_0];
          },[i35.ɵh]),i0.ɵmpd(4608,i35.ɵd,i35.ɵd,([] as any[])),i0.ɵmpd(6144,i35.XhrFactory,
              (null as any),[i35.ɵd]),i0.ɵmpd(4608,i35.HttpXhrBackend,i35.HttpXhrBackend,
              [i35.XhrFactory]),i0.ɵmpd(6144,i35.HttpBackend,(null as any),[i35.HttpXhrBackend]),
          i0.ɵmpd(5120,i35.HttpHandler,i35.ɵinterceptingHandler,[i35.HttpBackend,[2,
              i35.HTTP_INTERCEPTORS]]),i0.ɵmpd(4608,i35.HttpClient,i35.HttpClient,
              [i35.HttpHandler]),i0.ɵmpd(5120,i34.ActivatedRoute,i34.ɵf,[i34.Router]),
          i0.ɵmpd(4608,i34.NoPreloading,i34.NoPreloading,([] as any[])),i0.ɵmpd(6144,
              i34.PreloadingStrategy,(null as any),[i34.NoPreloading]),i0.ɵmpd(135680,
              i34.RouterPreloader,i34.RouterPreloader,[i34.Router,i0.NgModuleFactoryLoader,
                  i0.Compiler,i0.Injector,i34.PreloadingStrategy]),i0.ɵmpd(4608,i34.PreloadAllModules,
              i34.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i34.ROUTER_INITIALIZER,
              i34.ɵi,[i34.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i34.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i36.AuthGuard,i36.AuthGuard,[i32.AuthService,
              i34.Router]),i0.ɵmpd(4608,i37.CountryGuard,i37.CountryGuard,[i34.Router]),
          i0.ɵmpd(5120,i38.WINDOW,i38._window,([] as any[])),i0.ɵmpd(5120,i39.ClipboardService,
              i39.CLIPBOARD_SERVICE_PROVIDER_FACTORY,[i27.DOCUMENT,i38.WINDOW,[3,i39.ClipboardService]]),
          i0.ɵmpd(4608,i40.AnimationBuilder,i29.ɵBrowserAnimationBuilder,[i0.RendererFactory2,
              i27.DOCUMENT]),i0.ɵmpd(4608,i41.NotificationsService,i41.NotificationsService,
              ([] as any[])),i0.ɵmpd(4608,i30.FormBuilder,i30.FormBuilder,([] as any[])),
          i0.ɵmpd(4608,i42.TabsetConfig,i42.TabsetConfig,([] as any[])),i0.ɵmpd(4608,
              i43.PopoverConfig,i43.PopoverConfig,([] as any[])),i0.ɵmpd(4608,i44.PositioningService,
              i44.PositioningService,([] as any[])),i0.ɵmpd(4608,i45.ComponentLoaderFactory,
              i45.ComponentLoaderFactory,[i0.ComponentFactoryResolver,i0.NgZone,i0.Injector,
                  i44.PositioningService,i0.ApplicationRef]),i0.ɵmpd(4608,i46.ImageService,
              i46.ImageService,[i31.Http]),i0.ɵmpd(4608,i47.DatepickerConfig,i47.DatepickerConfig,
              ([] as any[])),i0.ɵmpd(4608,i48.BsDropdownState,i48.BsDropdownState,
              ([] as any[])),i0.ɵmpd(5120,i49.TranslateLoader,i1.HttpLoaderFactory,
              [i35.HttpClient]),i0.ɵmpd(4608,i50.TranslateCompiler,i50.TranslateFakeCompiler,
              ([] as any[])),i0.ɵmpd(4608,i51.TranslateParser,i51.TranslateDefaultParser,
              ([] as any[])),i0.ɵmpd(4608,i52.MissingTranslationHandler,i52.FakeMissingTranslationHandler,
              ([] as any[])),i0.ɵmpd(4608,i53.TranslateStore,i53.TranslateStore,([] as any[])),
          i0.ɵmpd(4608,i54.TranslateService,i54.TranslateService,[i53.TranslateStore,
              i49.TranslateLoader,i50.TranslateCompiler,i51.TranslateParser,i52.MissingTranslationHandler,
              i54.USE_DEFAULT_LANG,i54.USE_STORE]),i0.ɵmpd(4608,i55.WindowRef,i55.WindowRef,
              ([] as any[])),i0.ɵmpd(4608,i55.DocumentRef,i55.DocumentRef,([] as any[])),
          i0.ɵmpd(4608,i55.LazyStripeAPILoader,i55.LazyStripeAPILoader,[i55.WindowRef,
              i55.DocumentRef]),i0.ɵmpd(4608,i55.StripeService,i55.StripeService,[i55.STRIPE_PUBLISHABLE_KEY,
              i55.STRIPE_OPTIONS,i55.LazyStripeAPILoader,i55.WindowRef]),i0.ɵmpd(4608,
              i56.BillingService,i56.BillingService,[i31.Http,i32.AuthService]),i0.ɵmpd(4608,
              i57.GetService,i57.GetService,[i34.Router,i31.Http,i32.AuthService,i56.BillingService]),
          i0.ɵmpd(4608,i58.AppMemoryService,i58.AppMemoryService,[i57.GetService,i34.Router,
              i32.AuthService,i54.TranslateService]),i0.ɵmpd(4608,i59.AdminReportService,
              i59.AdminReportService,[i31.Http,i32.AuthService]),i0.ɵmpd(4608,i26.DatePipe,
              i26.DatePipe,[i0.LOCALE_ID]),i0.ɵmpd(135680,i60.SocetService,i60.SocetService,
              [i58.AppMemoryService,i32.AuthService]),i0.ɵmpd(4608,i61.BillingComponent,
              i61.BillingComponent,[i0.NgZone,i0.ApplicationRef,i56.BillingService]),
          i0.ɵmpd(4608,i62.DateObjPipe,i62.DateObjPipe,([] as any[])),i0.ɵmpd(512,
              i26.CommonModule,i26.CommonModule,([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,
              i27.ɵa,([] as any[])),i0.ɵmpd(1024,i0.NgProbeToken,() => {
            return [i34.ɵb()];
          },([] as any[])),i0.ɵmpd(512,i34.ɵg,i34.ɵg,[i0.Injector]),i0.ɵmpd(1024,i0.APP_INITIALIZER,
              (p0_0:any,p0_1:any,p1_0:any) => {
                return [i27.ɵc(p0_0,p0_1),i34.ɵh(p1_0)];
              },[[2,i27.NgProbeToken],[2,i0.NgProbeToken],i34.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i27.BrowserModule,i27.BrowserModule,[[3,i27.BrowserModule]]),
          i0.ɵmpd(512,i30.ɵba,i30.ɵba,([] as any[])),i0.ɵmpd(512,i30.FormsModule,i30.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i63.TextMaskModule,i63.TextMaskModule,([] as any[])),
          i0.ɵmpd(512,i31.HttpModule,i31.HttpModule,([] as any[])),i0.ɵmpd(512,i35.HttpClientXsrfModule,
              i35.HttpClientXsrfModule,([] as any[])),i0.ɵmpd(512,i35.HttpClientModule,
              i35.HttpClientModule,([] as any[])),i0.ɵmpd(1024,i34.ɵa,i34.ɵd,[[3,i34.Router]]),
          i0.ɵmpd(512,i34.UrlSerializer,i34.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,
              i34.ChildrenOutletContexts,i34.ChildrenOutletContexts,([] as any[])),
          i0.ɵmpd(256,i34.ROUTER_CONFIGURATION,{},([] as any[])),i0.ɵmpd(1024,i26.LocationStrategy,
              i34.ɵc,[i26.PlatformLocation,[2,i26.APP_BASE_HREF],i34.ROUTER_CONFIGURATION]),
          i0.ɵmpd(512,i26.Location,i26.Location,[i26.LocationStrategy]),i0.ɵmpd(512,
              i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,
              i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(1024,i34.ROUTES,() => {
            return [[{path:'',component:i64.RouteLoggedComponent,canActivate:[i36.AuthGuard],
                children:[{path:'',redirectTo:'horses',pathMatch:'full',canActivate:[i36.AuthGuard]},
                    {path:'horses',component:i65.HorsesComponent,canActivate:[i36.AuthGuard]},
                    {path:'yards/horses/:yard_id/:en_region',component:i65.HorsesComponent,
                        canActivate:[i36.AuthGuard]},{path:'horses/:horse_id',component:i66.HorseComponent,
                        canActivate:[i36.AuthGuard]},{path:'profile',component:i67.ProfileComponent,
                        canActivate:[i36.AuthGuard]},{path:'cat',component:i68.CatComponent,
                        canActivate:[i36.AuthGuard]},{path:'admin-report',component:i69.AdminReportComponent,
                        canActivate:[i36.AuthGuard,i37.CountryGuard]},{path:'weight-reporting',
                        component:i70.WeightReportingComponent,canActivate:[i36.AuthGuard]},
                    {path:'rules-book',component:i71.RuleBookComponent,canActivate:[i36.AuthGuard,
                        i37.CountryGuard]},{path:'contact',component:i72.ContactComponent,
                        canActivate:[i36.AuthGuard,i37.CountryGuard]},{path:'all-treatments',
                        component:i73.AllTreatmentsComponent,canActivate:[i36.AuthGuard,
                            i37.CountryGuard]},{path:'yards',component:i74.YardsComponent,
                        canActivate:[i36.AuthGuard,i37.CountryGuard]},{path:'billing',
                        component:i61.BillingComponent,canActivate:[i36.AuthGuard,
                            i37.CountryGuard]},{path:'invoices',component:i75.InvoicesComponent,
                        canActivate:[i36.AuthGuard,i37.CountryGuard]},{path:'info',
                        component:i76.InfoComponent,canActivate:[i36.AuthGuard,i37.CountryGuard]}]}],
                [{path:'login',component:i77.LoginComponent},{path:'sign',component:i78.SignComponent},
                    {path:'forgot',component:i79.ForgotComponent},{path:'rules',component:i80.RulesUnauthComponent},
                    {path:'locate',component:i81.LocateUnauthComponent}]];
          },([] as any[])),i0.ɵmpd(1024,i34.Router,i34.ɵe,[i0.ApplicationRef,i34.UrlSerializer,
              i34.ChildrenOutletContexts,i26.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i34.ROUTES,i34.ROUTER_CONFIGURATION,[2,i34.UrlHandlingStrategy],
              [2,i34.RouteReuseStrategy]]),i0.ɵmpd(512,i34.RouterModule,i34.RouterModule,
              [[2,i34.ɵa],[2,i34.Router]]),i0.ɵmpd(512,i82.AppRoutingModule,i82.AppRoutingModule,
              ([] as any[])),i0.ɵmpd(512,i83.LoginRoutingModule,i83.LoginRoutingModule,
              ([] as any[])),i0.ɵmpd(512,i38.WindowTokenModule,i38.WindowTokenModule,
              ([] as any[])),i0.ɵmpd(512,i84.ClipboardModule,i84.ClipboardModule,([] as any[])),
          i0.ɵmpd(512,i85.SelectModule,i85.SelectModule,([] as any[])),i0.ɵmpd(512,
              i29.NoopAnimationsModule,i29.NoopAnimationsModule,([] as any[])),i0.ɵmpd(512,
              i86.TabsModule,i86.TabsModule,([] as any[])),i0.ɵmpd(512,i87.ButtonsModule,
              i87.ButtonsModule,([] as any[])),i0.ɵmpd(512,i88.PopoverModule,i88.PopoverModule,
              ([] as any[])),i0.ɵmpd(512,i89.ImageUploadModule,i89.ImageUploadModule,
              ([] as any[])),i0.ɵmpd(512,i90.DatepickerModule,i90.DatepickerModule,
              ([] as any[])),i0.ɵmpd(512,i91.SimpleNotificationsModule,i91.SimpleNotificationsModule,
              ([] as any[])),i0.ɵmpd(512,i92.BsDropdownModule,i92.BsDropdownModule,
              ([] as any[])),i0.ɵmpd(512,i93.TranslateModule,i93.TranslateModule,([] as any[])),
          i0.ɵmpd(512,i94.ChartsModule,i94.ChartsModule,([] as any[])),i0.ɵmpd(512,
              i55.NgxStripeModule,i55.NgxStripeModule,([] as any[])),i0.ɵmpd(512,i30.ReactiveFormsModule,
              i30.ReactiveFormsModule,([] as any[])),i0.ɵmpd(512,i95.PdfViewerModule,
              i95.PdfViewerModule,([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,
              ([] as any[])),i0.ɵmpd(256,i35.ɵe,'XSRF-TOKEN',([] as any[])),i0.ɵmpd(256,
              i35.ɵf,'X-XSRF-TOKEN',([] as any[])),i0.ɵmpd(256,i96.BsDropdownConfig,
              {autoClose:true},([] as any[])),i0.ɵmpd(256,i54.USE_STORE,(undefined as any),
              ([] as any[])),i0.ɵmpd(256,i54.USE_DEFAULT_LANG,(undefined as any),([] as any[])),
          i0.ɵmpd(256,i55.STRIPE_PUBLISHABLE_KEY,'pk_test_37ClOdBt2dkVZ4Vp7wESYQZI00rxaDoF3n',
              ([] as any[])),i0.ɵmpd(256,i55.STRIPE_OPTIONS,(undefined as any),([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvYXBwLm1vZHVsZS5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3ZzdHMvd29yay8xL3MvZW1yLXdlYmFwcC9zcmMvYXBwL2FwcC5tb2R1bGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/app.module.ngfactory.ts